const liabilityLossTypeValues = [
    { value: 82, text: 'Liability-Miscellaneous', policyTypes: ['BOP'] },
    { value: 189, text: 'Liability-NOC', policyTypes: ['DFR', 'HOM', 'FAR', 'GAR'] },
    { value: 251, text: 'Other-NOC', policyTypes: ['CRM'] },
    { value: 82, text: 'Liability-NOC', policyTypes: ['CGL'] }
];

const cppLiabilityLossTypeValues = [
    { value: 189, text: 'Liability-NOB', packageParts: ['Garage'] },
    { value: 251, text: 'Liability-NOB', packageParts: ['Crime'] },
    { value: 82, text: 'Liability-NOB', packageParts: ['General Liability'] }
];

const otherLossTypeValues = [
    { value: 251, text: 'Other-NOC', policyTypes: ['CRM', 'CIM', 'CPR', 'CPP'] },
    { value: 211, text: 'Other-NOC', policyTypes: ['CAP', 'PPA'] },
    { value: 178, text: 'Other-NOC', policyTypes: ['DFR', 'FAR', 'HOM', 'PIM', 'GAR'] },
    { value: 55, text: 'Miscellaneous', policyTypes: ['BOP'] }
];

const cppOtherLossTypeValues = [
    { value: 251, text: 'Other-NOC', packageParts: ['Crime', 'General Liability', 'Property', 'Inland Marine'] },
    { value: 211, text: 'Other-NOC', packageParts: ['Garage'] }
];

const autoLossTypeValues = [            // INCLUDES GARAGE
    { value: 193, text: 'At least two vehicles involved in collision', isMedicalDisplayed: true },
    { value: 194, text: 'Only one vehicle involved in collision', isMedicalDisplayed: true },
    { value: 201, text: 'Damage only to glass', isMedicalDisplayed: false },
    { value: 208, text: 'Towing', isMedicalDisplayed: false },
    { value: 195, text: 'Contact with animal', isMedicalDisplayed: true },
    { value: -1, text: 'Other', isMedicalDisplayed: false }
];

const propertyLossTypeValues = [
    { value: 37, text: 'Fire' },
    { value: 39, text: 'Hail' },
    { value: 49, text: 'Theft' },
    { value: 59, text: 'Vandalism' },
    { value: 38, text: 'Wind/Tornado' },
    { value: -2, text: 'Water' },
    { value: -1, text: 'Other' }
];

const farmLossTypeValues = [
    { value: 213, text: 'Collision, Upset, Overturn' },
    { value: 37, text: 'Fire' },
    { value: 39, text: 'Hail' },
    { value: 215, text: 'Intake of Foreign Objects' },
    { value: 53, text: 'Lightning' },
    { value: 49, text: 'Theft' },
    { value: 177, text: 'Water Damage' },
    { value: 38, text: 'Wind/Tornado' },
    { value: -1, text: 'Other' }
];

const crmCppPropertyLossTypeValues = [
    { value: 245, text: 'Burglary' },
    { value: 162, text: 'Conversion' },
    { value: 246, text: 'Employee Dishonesty' },
    { value: 142, text: 'Forgery' },
    { value: 244, text: 'Robbery' },
    { value: 49, text: 'Theft' },
    { value: -1, text: 'Other' }
];

const pimLossTypeValues = [
    { value: 37, text: 'Fire' },
    { value: 49, text: 'Theft' },
    { value: 165, text: 'Animal Damage' },
    { value: 67, text: 'Mysterious Disappearance' },
    { value: 178, text: 'Something not listed here' },
];

const waterDamageLossTypeValues = [
    { value: 41, text: 'Sump pump or drain overflow', policyTypes: [], excludePolicyTypes: [] },
    { value: 61, text: 'Any other source', policyTypes: ['BOP'], excludePolicyTypes: [] },
    { value: 177, text: 'Any other source', policyTypes: [], excludePolicyTypes: ['BOP'] }
];

const otherDamageLossTypeValues = [
    { value: 254, text: 'Animal Damage', isAuto: false, policyTypes: ['BOP', 'CPR', 'CIM', 'CPP'] },
    { value: 165, text: 'Animal Damage', isAuto: false, policyTypes: ['FAR', 'DFR', 'HOM', 'PIM'] },
    { value: 248, text: 'Equipment Breakdown', isAuto: false, policyTypes: ['BOP'] },
    { value: 166, text: 'Equipment Breakdown', isAuto: false, policyTypes: ['CPR', 'CIM', 'FAR', 'DFR', 'HOM', 'PIM', 'CPP'] },
    { value: 53, text: 'Lightning', isAuto: false, policyTypes: null },
    { value: 67, text: 'Mysterious Disappearance', isAuto: false, policyTypes: null },
    { value: 57, text: 'Power Interruption', isAuto: false, policyTypes: ['BOP'] },          // 252
    { value: 179, text: 'Power Interruption', isAuto: false, policyTypes: ['CIM', 'CPR', 'HOM', 'DFR', 'CPP'] },
    { value: 252, text: 'Power Interruption', isAuto: false, policyTypes: ['PIM'] },
    { value: 176, text: 'Vehicle Damage', isAuto: false, policyTypes: null },
    { value: -1, text: 'Something not listed here', isAuto: false, policyTypes: null },
    { value: 199, text: 'Fire', isAuto: true, policyTypes: null },
    { value: 200, text: 'Flood', isAuto: true, policyTypes: null },
    { value: 203, text: 'Hail', isAuto: true, policyTypes: null },
    { value: 206, text: 'Theft', isAuto: true, policyTypes: null },
    { value: 209, text: 'Vandalism', isAuto: true, policyTypes: null },
    { value: 204, text: 'Water', isAuto: true, policyTypes: null },
    { value: 210, text: 'Wind', isAuto: true, policyTypes: null },
    { value: -1, text: 'Something not listed here', isAuto: true, policyTypes: null }
];

export {
    autoLossTypeValues,
    farmLossTypeValues,
    propertyLossTypeValues,
    crmCppPropertyLossTypeValues,
    waterDamageLossTypeValues,
    otherDamageLossTypeValues,
    liabilityLossTypeValues,
    cppLiabilityLossTypeValues,
    otherLossTypeValues,
    pimLossTypeValues,
    cppOtherLossTypeValues
}